import { TFunction } from 'i18next';
import {
  ValidationError,
  EValidationSeverity,
} from 'components/ui/excel-table/types';
import { BinderDeploymentRow } from './types';

export const validateBinderDeploymentRow = (
  row: BinderDeploymentRow,
  rowIndex: number,
  allRows: BinderDeploymentRow[],
  t: TFunction
): ValidationError<BinderDeploymentRow>[] => {
  const errors: ValidationError<BinderDeploymentRow>[] = [];

  if (row.isGroupRow || row.isAddRow) {
    return errors;
  }

  // Strict validations - will prevent syncing to backend
  if (!row.reinsured) {
    errors.push({
      field: 'reinsured',
      rowIndex,
      message: t('binderDeployment.reinsuredRequired'),
      severity: EValidationSeverity.STRICT,
    });
  }

  if (!row.sourceBroker) {
    errors.push({
      field: 'sourceBroker',
      rowIndex,
      message: t('binderDeployment.brokerRequired'),
      severity: EValidationSeverity.STRICT,
    });
  }

  if (!row.binder) {
    errors.push({
      field: 'binder',
      rowIndex,
      message: t('binderDeployment.binderRequired'),
      severity: EValidationSeverity.STRICT,
    });
  }

  if (!row.binderShareQuoted) {
    errors.push({
      field: 'binderShareQuoted',
      rowIndex,
      message: t('binderDeployment.binderShareRequired'),
      severity: EValidationSeverity.STRICT,
    });
  }

  // Check for duplicate contracts within the same layer
  if (row.layerNumber && row.reinsured && row.sourceBroker && row.binder) {
    const duplicateRows = allRows.filter(
      (r) =>
        !r.isGroupRow &&
        !r.isAddRow &&
        r.id !== row.id &&
        r.layerNumber === row.layerNumber &&
        r.reinsured === row.reinsured &&
        r.sourceBroker === row.sourceBroker &&
        r.binder === row.binder
    );

    if (duplicateRows.length > 0) {
      errors.push({
        field: 'binder',
        rowIndex,
        message: t('binderDeployment.duplicateContract'),
        severity: EValidationSeverity.STRICT,
      });
    }
  }

  // Check if total binder share exceeds 100%
  if (row.binderShareQuoted && row.layerNumber) {
    const layerRows = allRows.filter(
      (r) => r.layerNumber === row.layerNumber && !r.isGroupRow && !r.isAddRow
    );

    const totalShareInLayer = layerRows.reduce(
      (sum, r) => sum + (r.binderShareQuoted || 0),
      0
    );

    if (totalShareInLayer > 100) {
      errors.push({
        field: 'binderShareQuoted',
        rowIndex,
        message: t('binderDeployment.binderShareExceeds100'),
        severity: EValidationSeverity.STRICT,
      });
    }
  }

  return errors;
};
